<template>
    <div class="animated fadeIn">
    <b-form @submit.stop.prevent="onSubmit">

        <b-row>
            <b-col md="12">
        
                <b-form>
                    <b-form-group
                    :description="currentPasswordError"
                    label= "Senha do usuário atual"
                    label-for="currentpassword"
                    :label-cols="3"
                    :horizontal="true">
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="currentPassword" ref="currentPassword" type="password" :class="currentPasswordField" class="form-control" required placeholder="Senha do usuário atual" 
                                @blur="checkPassword()"  />
                        </b-input-group>
                    </b-form-group>          
                </b-form>
            </b-col>
          </b-row>

        <b-row>
            <b-col md="12">
        
                <b-form>
                    <b-form-group
                    :description="passwordError"
                    label="Nova senha"
                    label-for="password"
                    :label-cols="3"
                    :horizontal="true">
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="password" ref="password" type="password" :class="passwordField" class="form-control" required placeholder="Nova senha" 
                                 />
                        </b-input-group>
                    </b-form-group>          
                </b-form>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
        
                <b-form>
                    <b-form-group
                    :description="password2Error"
                    label="Confirmar senha"
                    label-for="password2"
                    :label-cols="3"
                    :horizontal="true">
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="password2" ref="password" type="password" :class="password2Field" class="form-control" required placeholder="Confirmar senha" 
                                @blur="checkPassword()"  />
                        </b-input-group>
                    </b-form-group>          
                </b-form>
            </b-col>
        </b-row>

        <div slot="footer" class="text-right">
            <b-button variant="primary" @click="changePassword()"><i class="fa fa-check"></i> Alterar Senha</b-button>
        </div>
    </b-form>
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  export default {
    name: 'changeUserPasswordComponent',
    props: {
        // Objeto USER
       selectedItem: {}
    },
    watch: {
        selectedItem: {
            immediate: true,
            handler(newValue) {
                this.selectedItem = newValue ? newValue : {}
            }
        },
    },
    computed: {
        currentUser() {
            return this.selectedItem
        }
    },
    components: {
    },
    data: () => {
        return {
            passwordPolicy: /^.{8,}$/,
            passwordPolicyMessage: 'No mínimo 8 caracteres',

            currentPassword: "",
            currentPasswordError: "",
            currentPasswordField: "",

            password: "",
            passwordField: "",
            passwordError: "",

            password2: "",            
            password2Field: "",
            password2Error: ""
        }
    },
    methods: {
        async changePassword() {
            var containsError = false
            var s = this

            this.checkPassword()
            if(this.password.length <= 0) {
                this.passwordField = 'is-invalid'
                containsError = true
            }
            else {
                this.passwordField = ''
            }

            if(this.password2.length <= 0) {
                this.password2Field = 'is-invalid'
                containsError = true
            }
            else {
                this.password2Field = ''
            }

            if(this.currentPassword.length <= 0) {
                this.currentPasswordField = 'is-invalid'
                containsError = true
            }
            else {
                this.currentPasswordField = ''
            }

            if(!containsError) {
            
                var userData = {
                    "id": this.currentUser.id,
                    "newPassword": this.password, 
                    "userPassword": this.currentPassword,
                    "uid": this.$store.state.currentUser.id ,
                    "sid": this.$store.state.currentUser.sid
                };

                await axios.post(
                    this.$store.state.ws_url + "/user/changepassword",
                    userData
                ).then(function(resp) {
                    s.$emit('resp', { code: 1, message: 'Senha alterada com sucesso' })
                }
                ).catch(function (error) {
                    toast ({
                        type: VueNotifications.types.error,
                        title: 'Alterar Senha',
                        message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                        timeout: 5000
                    })
                
                });                   
                
            }
            
        },

        checkPassword() {
            var s = this
            if(this.password && this.password.length > 0) {
                if(this.passwordPolicy.test(this.password)) {
                    s.passwordField = ''
                    s.passwordError = ''

                    if(this.password2 && this.password2.length > 0) {
                        s.password2Field = this.password === this.password2 ? '' : 'is-invalid'
                        s.password2Error = this.password === this.password2 ? '' : 'Senhas diferentes. Verifique e tente novamente.'
                        s.passwordField = ''
                        s.passwordError = ''
                    }
                }
                else {
                    s.passwordField = 'is-invalid'
                    s.passwordError = this.passwordPolicyMessage

                    s.password2Field = ''
                    s.password2Error = ''
                }
            }
            else {
                s.passwordField = ''
                s.passwordError = ''
            }
            
        },

        async getPreferences() {
            
            var s = this
            await axios.get(
                this.$store.state.ws_url + "/sys/preference/password/policy?companyId=" + this.$store.state.config.companyId
            ).then(function(resp) {
                s.passwordPolicy = new RegExp(resp.data.obj.stringPreference)
                s.passwordPolicyMessage = resp.data.obj.description
            }).catch(function(error) {
                s.passwordPolicy = /^.{8,}$/
            })
        },


        mounted: function() {
            this.getPreferences()
        }
    }
  }


</script>